
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      mapList: [
        { name: '服务中心', address: '深圳市南山区凯德·公园一号C座13楼', map: 'https://map.baidu.com/poi/@12682979.545,2557670.67,19z?uid=95d8e437bdf5262781a12ee3&querytype=detailConInfo' },
        { name: '培训中心', address: '深圳市南山区凯德·公园一号C座13楼', map: 'https://map.baidu.com/poi/@12682979.545,2557670.67,19z?uid=95d8e437bdf5262781a12ee3&querytype=detailConInfo' },
      ]
    };
  },

  methods: {
    toMap(address: string) {
      window.open(address);
    },
  },
});
